module.exports = __webpack_public_path__ + "static/media/03-Leipzig@2x.d71213b2.jpg";